import * as RegionActions from '../actions/region.actions';
import {Region} from '../../../core/models/region';

export interface State {
  regions: Region[] | null;
}

export const initialState: State = {
  regions: null,
};
export function reducer(
  state = initialState,
  action: RegionActions.RegionActionsUnion
): State {
  switch (action.type) {
    case RegionActions.getRegionsSuccess.type: {
      return {
        ...state,
        regions: action['regions']
      };
    }
    default: {
      return state;
    }
  }
}
export const getRegions = (state: State) => state.regions;
